import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

import LoadingSpinner from "../ui/loadingSpinner";
import {featureThumbnailUrl, isIE} from "../../misc/helpers";
import {baseNewImagesPath} from "../assets";
import {THUMBNAIL_SIZES} from "../../misc/utils";
import Config, {IS_LIXIL_UI} from "../../config";

const FeatureThumbnail = (props) => {

  const {feature, dbFeatureId, isMobile} = props;
  const [isLoading, toggleLoader] = useState(true);
  const [thumbnailUrl, setThumbnailUrl] = useState("");
  const [smallerSizeTried, setSmallerSizeTried] = useState(isIE() || Config.isDevMode()); // if it is ie - set smallerSizeTried to true
  const [regularSizeTried, setRegularSizeTried] = useState(isIE() || Config.isDevMode()); // if it is ie - skip the regular-thumbnail fallback too


  const setBaseThumbnail = () => {
    const size = isMobile && IS_LIXIL_UI
      ? THUMBNAIL_SIZES.small
      : isIE() || Config.isDevMode() ? THUMBNAIL_SIZES.medium : THUMBNAIL_SIZES.large
    const baseThumbnail = featureThumbnailUrl(feature, size) // if it is ie - set small Thumbnails by the default
    setThumbnailUrl(baseThumbnail || `${baseNewImagesPath}images/image-not-found.png`);
    return baseThumbnail;
  }

  useEffect(() => {
    toggleLoader(true);
    setSmallerSizeTried(isIE() || Config.isDevMode());
    setRegularSizeTried(isIE() || Config.isDevMode());
    setBaseThumbnail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dbFeatureId])

  const onImageLoadError = () => {
    if (isMobile || smallerSizeTried) {
      setThumbnailUrl(`${baseNewImagesPath}images/image-not-found.png`);
    } else if (!regularSizeTried) {
      toggleLoader(true);
      setThumbnailUrl(featureThumbnailUrl(feature)) // try the regular thumbnail (no THUMBNAIL_SIZES suffix) before falling back to a smaller size
      setRegularSizeTried(true)
    } else if (!smallerSizeTried) {
      toggleLoader(true);
      setThumbnailUrl(featureThumbnailUrl(feature, THUMBNAIL_SIZES.medium))
      setSmallerSizeTried(true)
    }
  };

  if (!thumbnailUrl && smallerSizeTried) { // no need to load anything, show not found
    return (
      <div className="feature-thumbnail">
        <img className={"feature-thumbnail__image"}
             src={`${baseNewImagesPath}images/image-not-found.png`}
             alt=""/>
      </div>
    )
  }

  return (
    <div className="feature-thumbnail">
      {thumbnailUrl
        ? <img className={"feature-thumbnail__image" + (isLoading ? " feature-thumbnail__image--loading" : "")}
               src={thumbnailUrl}
               onLoad={() => {
                 toggleLoader(false);
               }}
               onError={onImageLoadError}
               alt=""/>
        : null}
      {isLoading ? <LoadingSpinner/> : null}
    </div>
  )
};

FeatureThumbnail.propTypes = {
  feature: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
};

export default FeatureThumbnail
